import React from 'react';
import Icon from '../../../components/AppIcon';

const RegistrationProgress = ({ currentStep }) => {
  const steps = [
    { id: 1, label: 'Registration', icon: 'UserPlus' },
    { id: 2, label: 'Verification', icon: 'ShieldCheck' },
    { id: 3, label: 'Complete', icon: 'CheckCircle' }
  ];

  return (
    <div className="w-full max-w-3xl mx-auto mb-8">
      <div className="flex items-center justify-between">
        {steps?.map((step, index) => (
          <React.Fragment key={step?.id}>
            <div className="flex flex-col items-center gap-2 flex-1">
              <div
                className={`w-12 h-12 md:w-14 md:h-14 rounded-full flex items-center justify-center transition-smooth ${
                  currentStep >= step?.id
                    ? 'bg-primary text-primary-foreground shadow-lg'
                    : 'bg-muted text-muted-foreground'
                }`}
              >
                <Icon 
                  name={step?.icon} 
                  size={24} 
                  color={currentStep >= step?.id ? 'var(--color-primary-foreground)' : 'currentColor'} 
                />
              </div>
              <span
                className={`text-xs md:text-sm font-medium text-center ${
                  currentStep >= step?.id ? 'text-foreground' : 'text-muted-foreground'
                }`}
              >
                {step?.label}
              </span>
            </div>
            {index < steps?.length - 1 && (
              <div className="flex-1 h-1 mx-2 md:mx-4 relative">
                <div className="absolute inset-0 bg-muted rounded-full" />
                <div
                  className={`absolute inset-0 rounded-full transition-all duration-500 ${
                    currentStep > step?.id ? 'bg-primary w-full' : 'bg-primary w-0'
                  }`}
                />
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default RegistrationProgress;